<template>
    <div>
        <!-- v-model="display" -->
        <v-dialog
            persistent
            @input="$emit('input', $event)"
            :value="value"
            width="500">

            <v-card v-if="!submitted">
                <div v-if="!isloading">
                    <v-card-title>{{title}}</v-card-title>
                    <v-card-text>
                        <v-form>
                            <v-text-field 
                                v-model="form.name"
                                :rules="rule">                            
                            </v-text-field>
                        </v-form>
                        <v-card-actions>
                            <v-btn
                            :disabled="!form.name"
                            :loading="isloading"
                            @click="handelSave"
                            >
                                {{$t('BTN_SAVE')}}
                            </v-btn>
                            <v-btn
                            @click="handelClose">
                                {{$t('BTN_CANCEL')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </div>
                <div v-if="isloading">
                    <v-card-title>Please Wait</v-card-title>
                    <v-progress-linear
                        class="my-4"
                        indeterminate
                        color="yellow darken-2"
                    ></v-progress-linear>
                </div>
            </v-card>
            <v-card v-if="submitted">
                <v-card-title>{{$t("SUCCESSFULLY_PROCESS")}}</v-card-title>
                <v-card-subtitle>{{$t("FAILURE_HAS_BEEN_ADD")}}</v-card-subtitle>
                <v-card-actions>
                    <v-btn  @click="handelDone">Done</v-btn>
                    <v-btn @click="handelAddNewFailure">Add new Failure</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {addMalfaction} from '../services/malfactions'
export default {
    props: {
        title: String,
        value: Boolean
    },
    data() {
        return {
            display: false,
            form: {
                id: null,
                name: null
            },
            isloading: false,
            submitted: false,
            rule: [val => (val || '').length > 0 || this.$t("ADD_NEW_FAILURE" )]
        }
    },
    methods: {
        async handelSave() {
            this.isloading = true
            let response = await addMalfaction(this.form)
            this.$emit('addedRecord', response.data.record)
            this.form = {
                id: null,
                name: null
                }
            this.isloading = false
            this.submitted = true

        },
        handelClose() {
            this.submitted = false  
            this.$emit("cancel")        
        },
        handelDone() {
            this.submitted = false
            this.$emit('done')
        },
        handelAddNewFailure() {
            this.submitted = false
        }
    }
}
</script>

<style>

</style>